import { Injectable, Inject, Optional } from "@angular/core";
import { ServicesClient, HistoricalDataReq, API_BASE_URL, SwaggerException } from "./DixApiClient";
import { HttpClient, HttpHeaders, HttpResponseBase, HttpResponse } from "@angular/common/http";
import { mergeMap as _observableMergeMap, catchError as _observableCatch } from "rxjs/operators";
import { Observable, throwError as _observableThrow, of as _observableOf } from "rxjs";

@Injectable({
    providedIn: "root"
})
export class ServicesClientEx extends ServicesClient {
    private _http: HttpClient;
    private _baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        super(http, baseUrl);
        this._http = http;
        this._baseUrl = baseUrl ? baseUrl : "";
    }

    groupedRequestEx(data?: HistoricalDataReq[] | null | undefined, sessionKey?: string | null | undefined) {
        let url_ = this._baseUrl + "/api/Services/GroupedRequestAsync";
        // if (data !== undefined)
        //     data &&
        //         data.forEach(item => {
        //             url_ += "Data=" + encodeURIComponent("" + item) + "&";
        //         });
        // if (sessionKey !== undefined) url_ += "sessionKey=" + encodeURIComponent("" + sessionKey) + "&";
        // url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                Accept: "application/json"
            })
        };

        return this._http
            .post(
                url_,
                {
                    Data: data,
                    SessionKey: sessionKey
                },
                options_
            )
            .pipe(
                _observableMergeMap((value: any) => {
                    return this.processGroupedRequest(value);
                })
            )
            .pipe(
                _observableCatch((response_: any) => {
                    if (response_ instanceof HttpResponseBase) {
                        try {
                            return this.processGroupedRequest(<any>response_);
                        } catch (e) {
                            return <Observable<any>>(<any>_observableThrow(e));
                        }
                    } else return <Observable<string>>(<any>_observableThrow(response_));
                })
            );
    }

    protected processGroupedRequest(response: HttpResponseBase): Observable<any> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse
                ? response.body
                : (<any>response).error instanceof Blob
                ? (<any>response).error
                : undefined;

        let _headers: any = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap(_responseText => {
                    let result200: any = null;
                    let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                    //result200 = Stream.fromJS(resultData200);
                    return _observableOf(resultData200);
                })
            );
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap(_responseText => {
                    return throwException("An unexpected server error occurred.", status, _responseText, _headers);
                })
            );
        }
        return _observableOf<any>(<any>null);
    }
}

function blobToText(blob: any): Observable<string> {
    return new Observable<string>((observer: any) => {
        if (!blob) {
            observer.next("");
            observer.complete();
        } else {
            let reader = new FileReader();
            reader.onload = event => {
                observer.next((<any>event.target).result);
                observer.complete();
            };
            reader.readAsText(blob);
        }
    });
}

function throwException(
    message: string,
    status: number,
    response: string,
    headers: { [key: string]: any },
    result?: any
): Observable<any> {
    if (result !== null && result !== undefined) return _observableThrow(result);
    else return _observableThrow(new SwaggerException(message, status, response, headers, null));
}
